import { css, type Theme } from '@mui/material/styles';
import type { SerializedStyles } from '@mui/styled-engine';

const HEADER_HEIGHT = 80;

export const SIDE_NAV_WIDTH = 240;
export const TOP_BAR_HEIGHT = 54;

export const BASE_INPUT_HEIGHT = 32;
export const CONTAINER_SCROLL_LOCK_CLASS = 'container-scroll-lock';
export const SIDEBAR_TRANSITION_OPTIONS = { duration: 200, easing: 'linear' };

export const globalStyles = (theme: Theme): SerializedStyles => css`
  * {
    font-family: ${theme.typography.fontFamily};
    margin: 0;
    padding: 0;
  }

  &:root {
    --header-height: ${HEADER_HEIGHT}px;
    --topbar-height: ${TOP_BAR_HEIGHT}px;
  }

  body {
    min-width: 1280px;
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .${CONTAINER_SCROLL_LOCK_CLASS} {
    overflow: hidden;
    height: 100%;
  }

  #root {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;
  }

  a {
    color: ${theme.palette.primary.main};
    text-decoration: none;
  }

  @keyframes highlightFlash {
    from {
      background-color: rgba(76, 175, 80, 0.35);
    }
    to {
      background-color: transparent;
    }
  }

  .highlight-flash {
    animation: highlightFlash 1.5s ease-out;
  }

  @keyframes pulse-loading {
    0% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.5;
    }
  }

  ::-webkit-search-cancel-button {
    display: none;
  }
`;

/**
 * @deprecated - This is a temporary override. TODO EXCH-17466: remove `min-width` from body
 */
export const noMinWidthBody = css`
  body {
    min-width: initial;
  }
`;
